import { gql } from '@grandvisionhq/graphql';
import { appointmentFragment } from '../../../fragments/appointment.js';

const GET_APPOINTMENT_BY_TOKEN = gql`
  query CancelAppointment_GetAppointmentByToken($token: String!) {
    appointmentByToken(token: $token) {
      ...AppointmentFragment
    }
  }
  ${appointmentFragment}
`;

export { GET_APPOINTMENT_BY_TOKEN };
//# sourceMappingURL=get-appointment-by-token.js.map
